import $ from 'jquery';

export default class NewsAPIService {

    static buildAPIUrl(options) {
        const taxonomyOptions = [
            options.franchise,
            options.subfranchise,
            options.supercategory,
            options.category
        ].join('|');

        return `/bin/feedinfo.tag=${options.tag}|${taxonomyOptions}.limit=${options.limit}.json`;
    }

    static requestProductNews(options = {}) {
        options.tag = 'productsAndServices:taxonomy';
        options.limit = 4;

        return $.getJSON(this.buildAPIUrl(options));
    }
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/shared/News/NewsAPIService.js